import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Stack } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import { SubmitButton } from '../../../../common/button';
import { SelectFieldFormik } from '../../../../common/select_field';
import { EmployerReportType } from '../../../../../core/enums/benefit/employer';
import { getEmployerReport } from '../../../../../features/benefit';
import { getEmployerState } from '../../../../../features/benefit/get_employer';
import { getEmployerReportNotificationData } from '../../../../../core/utils/notification_utils';
import useNotification from '../../../../../core/hooks/use_notification';
import { parseDateString } from '../../../../../core/utils/date_utils';
import { MISC_DATE_ISO_FORMAT } from '../../../../../core/constants';
import { DateTimePickerFormik } from '../../../../common/date_picker';
import SectionPaper from '../../../../common/section_paper';
import BottomActionBar from '../../../../common/bottom_action_bar';

const reportTypeOptions = [
    { value: EmployerReportType.GENERAL.value, label: EmployerReportType.GENERAL.message },
    { value: EmployerReportType.EMPLOYEE.value, label: EmployerReportType.EMPLOYEE.message },
];

const ReportForm = () => {
    const { showNotification } = useNotification();
    const dispatch = useDispatch();

    const getEmployer = useSelector(getEmployerState);

    const initialValues = {
        fromDate: '',
        toDate: '',
        reportType: '',
    };

    const schema = Yup.object().shape({
        fromDate: Yup.date().transform(parseDateString).nullable().required(),
        toDate: Yup.date().transform(parseDateString).nullable().required(),
        reportType: Yup.string().required(),
    });

    const onSubmit = (values) => {
        const fromDate = values?.fromDate?.format(MISC_DATE_ISO_FORMAT);
        const toDate = values?.toDate?.format(MISC_DATE_ISO_FORMAT);

        const form = { ...values, fromDate, toDate };

        return dispatch(getEmployerReport({ employerId: getEmployer?.data?.id, form }))
            .then((response) => showNotification(getEmployerReportNotificationData(response)));
    };

    return (
        <Formik
            initialValues={ initialValues }
            validationSchema={ schema }
            validateOnChange={ false }
            validateOnBlur={ false }
            onSubmit={ onSubmit }
        >
            { ({ handleSubmit, isSubmitting }) => (
                <Box component={ Form } onSubmit={ handleSubmit }
                     sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, height: '100%' } }>

                    <Box sx={ { flexGrow: 1, pb: 4 } }>
                        <Stack spacing={ 3 }>

                            <SectionPaper
                                title="Generowanie raportów pracodawcy"
                                description="Wybierz zakres dat oraz typ raportu, aby pobrać szczegółowe zestawienie analityczne w formacie pliku."
                            >
                                <Grid container spacing={ 3 }>
                                    <Grid item xs={ 12 } md={ 4 }>
                                        <DateTimePickerFormik
                                            name="fromDate"
                                            label="Data od"
                                            required
                                            InputLabelProps={ { shrink: true } }
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={ 12 } md={ 4 }>
                                        <DateTimePickerFormik
                                            name="toDate"
                                            label="Data do"
                                            required
                                            InputLabelProps={ { shrink: true } }
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={ 12 } md={ 4 }>
                                        <SelectFieldFormik
                                            name="reportType"
                                            label="Typ raportu"
                                            options={ reportTypeOptions }
                                            required
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            </SectionPaper>

                        </Stack>
                    </Box>

                    <BottomActionBar>
                        <Box sx={ { display: 'flex', justifyContent: 'flex-end', width: '100%' } }>
                            <SubmitButton isLoading={ isSubmitting } sx={ { width: 160 } }>
                                Pobierz raport
                            </SubmitButton>
                        </Box>
                    </BottomActionBar>

                </Box>
            ) }
        </Formik>
    );
};

export default ReportForm;